<template>
  <div class="content">
    <!-- 封面图 -->
    <div
      class="top-banner"
      :style="{
        'background-image': 'url(' + $baseUrl + feedback1.cover_pc + ')',
      }"
    ></div>
    <!-- 学员反馈 -->
   <!--
   <section class="students">
      <div class="section-title">
        <h3>
          <span>学<div class="text-under-line"><div class="under-line"></div>员反</div>馈</span>
        </h3>
      </div>
      <div class="section-body">
        <div class="student" v-for="(item, index) in feedback2" :key="index">
          <img :src="$baseUrl + item.cover_pc" />
          <h6>{{ item.title_big_pc }}</h6>

          <p v-html="item.content"></p>
        </div>
      </div>
    </section>
    -->
    <!-- 家长说 -->
    <!-- <section class="feedback">
      <div class="section-title">
        <h3>
          <span>家<div class="text-under-line"><div class="under-line"></div>长</div>说</span>
        </h3>
      </div>
      <div class="swiper-container feedback-content">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="(item, index) in feedback3"
            :key="index"
          >
            <div>
              <img
                src="../assets/imgs/index42.png"
                class="feedback-left-quotation"
              />
              <img
                src="../assets/imgs/index43.png"
                class="feedback-right-quotation"
              />
              <div class="feedback-body-left">
                <img :src="$baseUrl + item.cover_pc" />
                <p>{{ item.title_big_pc }}</p>
                <p>{{ item.title_small_pc }}</p>
              </div>
              <div class="feedback-body-right" v-html="item.content"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="feedback-pagination"></div>
      <div class="feedback-button-prev">
        <img src="../assets/imgs/index44.png" />
      </div>
      <div class="feedback-button-next">
        <img src="../assets/imgs/index45.png" />
      </div>
    </section>-->
    <!-- 教具 -->
    <section class="sec3 realia">
      <div class="section-title">
        <h3>
          <span>正<div class="text-under-line"><div class="under-line"></div>版教</div>具</span>
        </h3>
      </div>
      <div class="section-body">
        <div class="img-f1">
          <img
            :src="$baseUrl + feedback4[0].cover_pc"
            v-if="feedback4.length != 0"
          />
          <div>
            <img
              :src="$baseUrl + feedback4[1].cover_pc"
              v-if="feedback4.length != 0"
            />
            <img
              :src="$baseUrl + feedback4[2].cover_pc"
              v-if="feedback4.length != 0"
            />
          </div>
        </div>
        <div class="img-f1">
          <img
            :src="$baseUrl + feedback4[3].cover_pc"
            v-if="feedback4.length != 0"
          />
          <img
            :src="$baseUrl + feedback4[4].cover_pc"
            v-if="feedback4.length != 0"
          />
          <img
            :src="$baseUrl + feedback4[5].cover_pc"
            v-if="feedback4.length != 0"
          />
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import $ from "jquery";
import { getPage, getSwiper } from "@/api/api.js";
import Swiper from "swiper/dist/js/swiper.js";
export default {
  data() {
    return {
      //封面图
      feedback1: {},
      //学员反馈
      feedback2: [],
      //家长说
      feedback3: [],
      //教具
      feedback4: [],
    };
  },
  created() {
    //查询该页面内容
    this.fetchData();
    //查询轮播图
    this.getSwipers();
  },
  updated() {
    $("p").find("span").css("color", "rgba(153, 153, 153, 1)");
  },
  methods: {
    getSwipers() {
      getSwiper({ c_tid: 6 }).then((res) => {
        this.feedback4 = res.data.backData;
      });
    },
    //查询页面模块
    fetchData() {
      getPage({ c_tid: 1 }).then((res) => {
        this.feedback3 = res.data.st_17; //反馈
        //初始化页面动画
        this.$nextTick(() => {
          this.init();
        });
      });
      getPage({ c_tid: 6 }).then((res) => {
        this.feedback1 = res.data.st_31[0]; //封面图
        this.feedback2 = res.data.st_32; //学员反馈
      });
    },
    chooseItem(n) {
      this.current = n;
    },
    //初始化轮播
    init() {
      var mySwiper = new Swiper(".feedback-content", {
        watchSlidesProgress: true,
        slidesPerView: "auto",
        centeredSlides: true,
        loop: true,
        loopedSlides: 5,
        autoplay: true,
        navigation: {
          nextEl: ".feedback-button-next",
          prevEl: ".feedback-button-prev",
        },
        pagination: {
          el: ".feedback-pagination",
        },
        on: {
          progress: function (progress) {
            for (var i = 0; i < this.slides.length; i++) {
              var slide = this.slides.eq(i);
              var slideProgress = this.slides[i].progress;
              if (Math.abs(slideProgress) > 0) {
                var translate = slideProgress * 655 + "px";
                var scale = 260 / 353;
                slide.transform(
                  "translateX(" + translate + ") scale(" + scale + ")"
                );
                slide.css("zIndex", 8);
              } else {
                slide.transform("translateX(0) scale(1)");
                slide.css("zIndex", 9);
              }
              slide.css("opacity", 1);
              if (Math.abs(slideProgress) > 1) {
                slide.css("opacity", 0);
              }
            }
          },
          setTransition: function (transition) {
            for (var i = 0; i < this.slides.length; i++) {
              var slide = this.slides.eq(i);
              slide.transition(transition);
            }
          },
        },
      });
    },
  },
  mounted() {},
};
</script>
<style scoped>
@import "../assets/css/common.css";
.top-banner {
  width: 100%;
  height: 500px;

  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}
.section-title {
  text-align: center;
}
.section-title > h3 {
  font-size: 36px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(26, 26, 26, 1);
  margin-bottom: 33px;
  margin-top: 0;
}
.section-title > p {
  font-size: 18px;
  font-weight: 400;
  color: rgba(115, 115, 115, 1);
  margin: 13px 0 0 0;
}
.text-under-line {
  display: inline-block;
  position: relative;
}
.under-line {
  position: absolute;
  width: 80%;
  height: 5px;
  border-radius: 5px;
  bottom: -15px;
  left: 0;
  right: 0;
  margin: 0 auto;
  background-color: #ff3500;
}
.students {
  margin: 83px 0 58px;
}
.section-body {
  width: 1200px;
  word-break: break-all;
}

.students .section-body {
  margin: 95px auto 0;
  display: flex;
  justify-content: space-between;
}
.student {
  width: 285px;
  height: 350px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 27px 0px rgba(192, 192, 192, 0.35);
  border-radius: 20px;
  box-sizing: border-box;
  padding: 17px 12px;
  text-align: center;
}
.student > img {
  width: 260px;
}
.student:hover {
  box-shadow: 0px 0px 27px 0px rgba(0, 0, 0, 0.35);
  transform: translateY(-10px);
}
.student > h6 {
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(0, 0, 0, 1);
  margin: 26px 0;
}
.student > p {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(128, 128, 128, 1);
  margin: 8px 0;
}

.feedback {
  position: relative;
  padding: 58px 0;
}
.feedback-content {
  width: 1200px;
  margin: 70px auto 47px;
}
.feedback-content .swiper-slide {
  width: 890px;
  height: 373px;
}
.feedback-content .swiper-slide > div {
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 13px 0px rgba(224, 224, 224, 1);
  border-radius: 5px;
  margin: 10px 0 15px;
  width: 870px;
  height: 348px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.feedback-body-left {
  text-align: center;
}
.feedback-body-left > img {
  width: 90px;
  height: 90px;
  border-radius: 50%;
  border: 1px solid rgb(172, 172, 172);
  margin-bottom: 13px;
}
.feedback-body-left > p {
  font-size: 16px;
  font-weight: 400;
  color: #404040;
  margin: 0;
}
.feedback-body-right {
  color: #999999;
  font-size: 16px;
  text-align: justify;
  line-height: 25px;
  width: 538px;
  padding-left: 44px;
}
.feedback-left-quotation,
.feedback-right-quotation {
  position: absolute;
}
.feedback-left-quotation {
  left: 42px;
  top: 42px;
}
.feedback-right-quotation {
  right: 42px;
  bottom: 42px;
}
.feedback-button-prev,
.feedback-button-next {
  position: absolute;
  z-index: 100;
  top: 330px;
  outline: none;
}
.feedback-button-prev {
  left: 280px;
}
.feedback-button-next {
  right: 300px;
}
.feedback-pagination {
  text-align: center;
}
::v-deep .swiper-pagination-bullet {
  margin: 0 7px;
  width: 15px;
  height: 15px;
  background: rgba(140, 140, 140, 1);
  border-radius: 50%;
  vertical-align: middle;
}
::v-deep .swiper-pagination-bullet-active {
  width: 27px;
  height: 10px;
  background: rgba(255, 156, 0, 1);
  border-radius: 5px;
}

.realia .section-body {
  text-align: right;
  margin: 90px auto 120px;
}
.img-f1 {
  display: flex;
  justify-content: space-between;
}
.img-f1 div img {
  display: block;
}
.img-f1 div img:first-child {
  margin-bottom: 18px;
}
.img-f1:first-child {
  margin-bottom: 18px;
}
.img-f1 img {
  transition: transform 0.3s;
}
.img-f1 img:hover {
  transform: scale(0.95);
}
</style>